import { create } from 'zustand';

const useSessionStore = create((set) => ({
    isSessionExpired: false,
    error: null,
    setSessionExpired: (value) => set({ isSessionExpired: value }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    resetSessionState: () => set({
        isSessionExpired: false,
        error: null
    }),
}));

export default useSessionStore;